import { render, staticRenderFns } from "./Meus-Alunos.vue?vue&type=template&id=01279e0e&scoped=true&"
import script from "./Meus-Alunos.vue?vue&type=script&lang=js&"
export * from "./Meus-Alunos.vue?vue&type=script&lang=js&"
import style0 from "./Meus-Alunos.vue?vue&type=style&index=0&id=01279e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01279e0e",
  null
  
)

component.options.__file = "Meus-Alunos.vue"
export default component.exports